(function() {
  'use strict';

  window.theme = window.theme || {};

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === 'undefined' ? 2 : precision;
    thousands = thousands || ',';
    decimal = decimal || '.';

    if (isNaN(number) || number == null) {
      return '0';
    }

    var parts = (number / 100.0).toFixed(precision).split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var formatString = format || '{{amount}}';
    var placeholder = formatString.match(/\{\{\s*(\w+)\s*\}\}/);

    if (!placeholder) {
      return formatString;
    }

    var value;

    switch (placeholder[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholder[0], value);
  }

  function setElementVisible(element, visible) {
    if (!element) {
      return;
    }

    element.style.display = visible ? '' : 'none';
  }

  function updateProductImage(container, variant) {
    if (!variant || !variant.featured_image || !variant.featured_image.src) {
      return;
    }

    var image = container.querySelector('.mgw-product-featured img');

    if (!image) {
      return;
    }

    image.src = variant.featured_image.src;
    image.removeAttribute('srcset');

    if (variant.featured_image.alt) {
      image.alt = variant.featured_image.alt;
    }
  }

  function updateProductUrl(variant) {
    if (!variant || !window.history || !window.history.replaceState) {
      return;
    }

    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({ path: url.toString() }, '', url.toString());
  }

  function initProductForms() {
    var containers = document.querySelectorAll('[data-section-type="product-template"]');

    Array.prototype.forEach.call(containers, function(container) {
      var sectionId = container.getAttribute('data-section-id');
      var productJson = document.getElementById('ProductJson-' + sectionId);
      var variantSelect = container.querySelector('select[name="id"]');

      if (!productJson || !variantSelect) {
        return;
      }

      var product;

      try {
        product = JSON.parse(productJson.textContent);
      } catch (error) {
        return;
      }

      var addToCart = container.querySelector('#AddToCart');
      var addToCartText = container.querySelector('#AddToCartText');
      var productPrice = container.querySelector('#ProductPrice');
      var quantity = container.querySelector('.product-single__quantity');
      var paymentButton = container.querySelector('.shopify-payment-button');
      var enableHistoryState = container.getAttribute('data-enable-history-state') === 'true';

      function findVariant(id) {
        return product.variants.filter(function(variant) {
          return String(variant.id) === String(id);
        })[0];
      }

      function updateVariant() {
        var variant = findVariant(variantSelect.value);

        if (!variant) {
          if (addToCart) {
            addToCart.disabled = true;
            addToCart.classList.add('disabled');
          }

          if (addToCartText) {
            addToCartText.textContent = window.theme.strings.unavailable;
          }

          setElementVisible(quantity, false);
          setElementVisible(paymentButton, false);
          return;
        }

        if (productPrice) {
          productPrice.innerHTML = formatMoney(variant.price, window.theme.moneyFormat);
        }

        updateProductImage(container, variant);

        if (variant.available) {
          if (addToCart) {
            addToCart.disabled = false;
            addToCart.classList.remove('disabled');
          }

          if (addToCartText) {
            addToCartText.textContent = window.theme.strings.addToCart;
          }

          setElementVisible(quantity, true);
          setElementVisible(paymentButton, true);
        } else {
          if (addToCart) {
            addToCart.disabled = true;
            addToCart.classList.add('disabled');
          }

          if (addToCartText) {
            addToCartText.textContent = window.theme.strings.soldOut;
          }

          setElementVisible(quantity, false);
          setElementVisible(paymentButton, false);
        }

        if (enableHistoryState) {
          updateProductUrl(variant);
        }
      }

      variantSelect.addEventListener('change', updateVariant);
      updateVariant();
    });
  }

  function initDropCountdowns() {
    var countdowns = document.querySelectorAll('[data-drop-countdown]');

    if (!countdowns.length) {
      return;
    }

    function isCartAddUrl(input) {
      var url = '';

      if (typeof input === 'string') {
        url = input;
      } else if (input && input.url) {
        url = input.url;
      }

      if (!url) {
        return false;
      }

      return /\/cart\/add(\.js)?(\?|$)/.test(url);
    }

    function hasLockedDrop() {
      return !!document.querySelector('[data-section-type="product-template"][data-drop-cart-locked]');
    }

    function blockLockedCartAdd(event) {
      var target = event.target;
      var form = target.closest ? target.closest('form') : null;
      var lockedSection = target.closest ? target.closest('[data-section-type="product-template"][data-drop-cart-locked]') : null;

      if (!lockedSection) {
        return;
      }

      if (event.type === 'submit') {
        if (form && isCartAddUrl(form.getAttribute('action') || '')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }

        return;
      }

      if (target.closest('#AddToCart, .shopify-payment-button, .shopify-payment-button *')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }

    function installDropCartGuard() {
      if (window.mgwDropCartGuardInstalled) {
        return;
      }

      window.mgwDropCartGuardInstalled = true;
      document.addEventListener('submit', blockLockedCartAdd, true);
      document.addEventListener('click', blockLockedCartAdd, true);

      if (window.fetch) {
        var originalFetch = window.fetch;
        window.fetch = function(input, init) {
          if (hasLockedDrop() && isCartAddUrl(input)) {
            return Promise.reject(new Error('Drop is not open yet.'));
          }

          return originalFetch.apply(this, arguments);
        };
      }

      if (window.XMLHttpRequest) {
        var originalOpen = window.XMLHttpRequest.prototype.open;
        var originalSend = window.XMLHttpRequest.prototype.send;

        window.XMLHttpRequest.prototype.open = function(method, url) {
          this._mgwDropCartUrl = url;
          return originalOpen.apply(this, arguments);
        };

        window.XMLHttpRequest.prototype.send = function() {
          if (hasLockedDrop() && isCartAddUrl(this._mgwDropCartUrl)) {
            this.abort();
            return;
          }

          return originalSend.apply(this, arguments);
        };
      }
    }

    function pad(value) {
      return value < 10 ? '0' + value : String(value);
    }

    function setPurchaseLocked(countdown, locked) {
      var productSection = countdown.closest('[data-section-type="product-template"]');
      var productShell = countdown.closest('.mgw-product');

      if (productShell) {
        productShell.classList.toggle('is-drop-locked', locked);
        productShell.classList.toggle('is-drop-open', !locked);
      }

      if (!productSection) {
        return;
      }

      var addToCart = productSection.querySelector('#AddToCart');
      var addToCartText = productSection.querySelector('#AddToCartText');
      var quantity = productSection.querySelector('.product-single__quantity');
      var paymentButton = productSection.querySelector('.shopify-payment-button');
      var wasLocked = addToCart && addToCart.getAttribute('data-drop-locked') === 'true';
      var variantSelect = productSection.querySelector('select[name="id"]');
      var productForm = productSection.querySelector('form[action*="/cart/add"]');

      productSection.toggleAttribute('data-drop-cart-locked', locked);

      if (productForm) {
        productForm.toggleAttribute('data-drop-cart-locked', locked);
      }

      if (addToCart) {
        if (!addToCart.hasAttribute('data-drop-original-disabled')) {
          addToCart.setAttribute('data-drop-original-disabled', addToCart.disabled ? 'true' : 'false');
        }

        if (locked) {
          addToCart.setAttribute('data-drop-locked', 'true');
          addToCart.disabled = true;
          addToCart.classList.add('disabled');
        } else if (wasLocked) {
          addToCart.removeAttribute('data-drop-locked');
          addToCart.disabled = addToCart.getAttribute('data-drop-original-disabled') === 'true';
          addToCart.classList.remove('disabled');
        }
      }

      if (addToCartText) {
        if (!addToCartText.hasAttribute('data-drop-original-text')) {
          addToCartText.setAttribute('data-drop-original-text', addToCartText.textContent);
        }

        if (locked) {
          addToCartText.textContent = 'Prodej brzy začne';
        } else if (wasLocked) {
          addToCartText.textContent = addToCartText.getAttribute('data-drop-original-text');
        }
      }

      if (quantity) {
        if (locked) {
          quantity.setAttribute('data-drop-hidden', 'true');
          quantity.style.display = 'none';
        } else if (quantity.getAttribute('data-drop-hidden') === 'true') {
          quantity.removeAttribute('data-drop-hidden');
          quantity.style.display = '';
        }
      }

      if (paymentButton) {
        if (locked) {
          paymentButton.setAttribute('data-drop-hidden', 'true');
          paymentButton.style.display = 'none';
        } else if (paymentButton.getAttribute('data-drop-hidden') === 'true') {
          paymentButton.removeAttribute('data-drop-hidden');
          paymentButton.style.display = '';
        }
      }

      if (!locked && wasLocked && variantSelect) {
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    installDropCartGuard();

    Array.prototype.forEach.call(countdowns, function(countdown) {
      var launchAt = countdown.getAttribute('data-launch-at');
      var launchTime = launchAt ? new Date(launchAt).getTime() : NaN;

      if (!launchTime) {
        countdown.style.display = 'none';
        return;
      }

      var reloadKey = 'mgw-drop-reloaded-' + launchAt;
      var wasCountingDown = launchTime > Date.now();
      var daysEl = countdown.querySelector('[data-drop-days]');
      var hoursEl = countdown.querySelector('[data-drop-hours]');
      var minutesEl = countdown.querySelector('[data-drop-minutes]');
      var secondsEl = countdown.querySelector('[data-drop-seconds]');
      var variantSelect = countdown.closest('[data-section-type="product-template"]');

      function updateCountdown() {
        var distance = launchTime - Date.now();
        var locked = distance > 0;

        countdown.classList.toggle('is-open', !locked);
        setPurchaseLocked(countdown, locked);

        if (!locked) {
          if (wasCountingDown) {
            try {
              if (window.sessionStorage.getItem(reloadKey) !== 'true') {
                window.sessionStorage.setItem(reloadKey, 'true');
                window.location.reload();
                return;
              }
            } catch (error) {
              window.location.reload();
              return;
            }
          }

          wasCountingDown = false;
          countdown.hidden = true;
          if (daysEl) daysEl.textContent = '00';
          if (hoursEl) hoursEl.textContent = '00';
          if (minutesEl) minutesEl.textContent = '00';
          if (secondsEl) secondsEl.textContent = '00';
          return;
        }

        countdown.hidden = false;

        var seconds = Math.floor(distance / 1000);
        var days = Math.floor(seconds / 86400);
        var hours = Math.floor((seconds % 86400) / 3600);
        var minutes = Math.floor((seconds % 3600) / 60);
        var remainingSeconds = seconds % 60;

        if (daysEl) daysEl.textContent = pad(days);
        if (hoursEl) hoursEl.textContent = pad(hours);
        if (minutesEl) minutesEl.textContent = pad(minutes);
        if (secondsEl) secondsEl.textContent = pad(remainingSeconds);

      }

      updateCountdown();
      window.setInterval(updateCountdown, 1000);

      if (variantSelect) {
        Array.prototype.forEach.call(variantSelect.querySelectorAll('select[name="id"]'), function(select) {
          select.addEventListener('change', function() {
            window.setTimeout(updateCountdown, 0);
          });
        });
      }
    });
  }

  function initCart() {
    var cartSection = document.getElementById('CartSection');

    if (!cartSection) {
      return;
    }

    if (!navigator.cookieEnabled) {
      document.cookie = 'testcookie';

      if (document.cookie.indexOf('testcookie') === -1) {
        cartSection.classList.add('cart--no-cookies');
      }
    }

    var cartForm = cartSection.querySelector('form.cart');
    var updateButton = cartSection.querySelector('[data-cart-update-button]');
    var quantityInputs = cartSection.querySelectorAll('.cart__quantity-selector');
    var lockedDropItems = cartSection.querySelectorAll('[data-drop-locked-cart-item][data-cart-line]');

    if (lockedDropItems.length && window.fetch) {
      cartSection.classList.add('is-updating');

      var removals = Array.prototype.map.call(lockedDropItems, function(item) {
        return window.fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            line: Number(item.getAttribute('data-cart-line')),
            quantity: 0
          })
        });
      });

      Promise.all(removals).then(function() {
        window.location.reload();
      }).catch(function() {
        window.location.href = '/cart';
      });

      return;
    }

    if (cartForm && updateButton && quantityInputs.length) {
      var updateTimer;

      function submitCartUpdate() {
        window.clearTimeout(updateTimer);
        cartSection.classList.add('is-updating');

        if (cartForm.requestSubmit) {
          cartForm.requestSubmit(updateButton);
          return;
        }

        updateButton.click();
      }

      Array.prototype.forEach.call(quantityInputs, function(input) {
        input.addEventListener('input', function() {
          window.clearTimeout(updateTimer);
          updateTimer = window.setTimeout(submitCartUpdate, 700);
        });

        input.addEventListener('change', submitCartUpdate);
      });
    }

    if (cartSection.getAttribute('data-notes-enable') !== 'true') {
      return;
    }

    var noteButton = cartSection.querySelector('.cart__note-add');
    var note = cartSection.querySelector('.cart__note');

    if (!noteButton || !note) {
      return;
    }

    noteButton.addEventListener('click', function() {
      noteButton.classList.add('is-hidden');
      note.classList.add('is-active');
    });
  }

  function initHeroHeight() {
    var nav = document.querySelector('.mgw-nav');
    var heroMedia = document.querySelectorAll('.mgw-header-video-desktop, .mgw-header-video-mobile, .mgw-header-slideshow');

    if (!nav || !heroMedia.length) {
      return;
    }

    function resizeHeroMedia() {
      var height = Math.max(window.innerHeight - nav.clientHeight, 320);

      Array.prototype.forEach.call(heroMedia, function(media) {
        media.style.height = height + 'px';
      });
    }

    resizeHeroMedia();
    window.addEventListener('resize', resizeHeroMedia);
  }

  function initHeroVideos() {
    var videos = document.querySelectorAll('.mgw-header-video-desktop, .mgw-header-video-mobile');

    if (!videos.length) {
      return;
    }

    function isVisible(video) {
      var styles = window.getComputedStyle(video);
      return styles.display !== 'none' && styles.visibility !== 'hidden';
    }

    function prepare(video) {
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.setAttribute('preload', 'auto');
      video.removeAttribute('controls');
    }

    function play(video) {
      prepare(video);

      if (!isVisible(video)) {
        return;
      }

      var promise = video.play();

      if (promise && promise.catch) {
        promise.catch(function() {});
      }
    }

    function playAll() {
      Array.prototype.forEach.call(videos, play);
    }

    Array.prototype.forEach.call(videos, function(video) {
      prepare(video);

      video.addEventListener('loadeddata', function() {
        play(video);
      });

      video.addEventListener('canplay', function() {
        play(video);
      });

      video.addEventListener('pause', function() {
        if (!video.ended) {
          window.setTimeout(function() {
            play(video);
          }, 100);
        }
      });
    });

    playAll();
    window.addEventListener('pageshow', playAll);
    window.addEventListener('focus', playAll);
    window.addEventListener('resize', playAll);
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) {
        playAll();
      }
    });
    document.addEventListener('touchstart', playAll, { once: true, passive: true });
  }

  function initHeroSlideshows() {
    var slideshows = document.querySelectorAll('.mgw-header-slideshow');

    if (!slideshows.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    Array.prototype.forEach.call(slideshows, function(slideshow) {
      var header = slideshow.closest('[data-mgw-header]');
      var slides = slideshow.querySelectorAll('.mgw-header-slide');
      var interval = header ? parseInt(header.getAttribute('data-slide-interval'), 10) : 5000;
      var activeIndex = 0;

      if (slides.length < 2) {
        return;
      }

      if (!interval || interval < 3000) {
        interval = 5000;
      }

      window.setInterval(function() {
        slides[activeIndex].classList.remove('is-active');
        activeIndex = (activeIndex + 1) % slides.length;
        slides[activeIndex].classList.add('is-active');
      }, interval);
    });
  }

  function scrollToTarget(target, updateUrl) {
    var top = target.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });

    if (updateUrl && window.history && window.history.pushState) {
      window.history.pushState(null, '', '#' + target.id);
    }
  }

  function initSmoothAnchors() {
    document.addEventListener('click', function(event) {
      var link = event.target.closest('a[href^="#"]');

      if (!link) {
        return;
      }

      var hash = link.getAttribute('href');

      if (!hash || hash === '#') {
        return;
      }

      var target = document.getElementById(hash.slice(1));

      if (!target) {
        return;
      }

      event.preventDefault();
      scrollToTarget(target, true);
    });

    if (window.location.hash.length > 1) {
      window.addEventListener('load', function() {
        var target = document.getElementById(window.location.hash.slice(1));

        if (target) {
          scrollToTarget(target, false);
        }
      });
    }
  }

  function initPasswordModal() {
    var modal = document.getElementById('LoginModal');
    var triggers = document.querySelectorAll('.js-toggle-login-modal');

    if (!modal || !triggers.length) {
      return;
    }

    var overlay;
    var closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'password-modal__close';
    closeButton.textContent = window.password && window.password.strings ? window.password.strings.pageClose : 'Close';
    closeButton.style.cssText = 'position:absolute;right:16px;top:12px;background:transparent;border:0;font:inherit;cursor:pointer;';
    modal.insertBefore(closeButton, modal.firstChild);
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-hidden', 'true');

    function closeModal() {
      modal.classList.add('mfp-hide');
      modal.setAttribute('aria-hidden', 'true');
      modal.removeAttribute('style');

      if (overlay) {
        overlay.remove();
        overlay = null;
      }

      document.removeEventListener('keydown', onKeyDown);
    }

    function onKeyDown(event) {
      if (event.key === 'Escape') {
        closeModal();
      }
    }

    function openModal(event) {
      if (event) {
        event.preventDefault();
      }

      overlay = document.createElement('div');
      overlay.className = 'password-modal__overlay';
      overlay.style.cssText = 'position:fixed;inset:0;z-index:10000;background:rgba(0,0,0,.55);';
      document.body.appendChild(overlay);

      modal.classList.remove('mfp-hide');
      modal.setAttribute('aria-hidden', 'false');
      modal.style.cssText = 'position:fixed;left:50%;top:50%;z-index:10001;width:min(90vw,560px);max-height:90vh;overflow:auto;transform:translate(-50%,-50%);background:#fff;padding:40px 28px 28px;box-shadow:0 20px 60px rgba(0,0,0,.3);display:block;';
      document.addEventListener('keydown', onKeyDown);

      var passwordInput = document.getElementById('password');

      if (passwordInput) {
        window.setTimeout(function() {
          passwordInput.focus();
        }, 50);
      }
    }

    Array.prototype.forEach.call(triggers, function(trigger) {
      trigger.addEventListener('click', openModal);
    });

    closeButton.addEventListener('click', closeModal);

    if (modal.querySelector('.errors')) {
      openModal();
    }
  }

  ready(function() {
    initProductForms();
    initDropCountdowns();
    initCart();
    initHeroHeight();
    initHeroVideos();
    initHeroSlideshows();
    initSmoothAnchors();
    initPasswordModal();
  });
})();
